/**
 * Checks if the selection is equal to or longer than the minimum length.
 *
 * If no selection exists it will check if the document is equal too or longer than the minimum length.
 * Includes whitespace, like empty paragraphs, when calculating the length.
 */
// NOTE: To match the backend minimum length we should parse
// to markdown and check the length of the markdown string.
export function isMinLength(_ref) {
  var editorView = _ref.editorView,
    minLength = _ref.minLength,
    positions = _ref.positions;
  // If there is no selection
  // Or there is an empty selection and the FF is enabled
  if (!positions || positions && positions[0] === positions[1]) {
    var doc = editorView.state.doc;
    // Size of the doc with a single empty paragraph is 4
    var positionDiff = doc.nodeSize - 4;
    return positionDiff >= minLength;
  }
  // If there is a selection
  else if (positions && positions[0] !== positions[1]) {
    var _positionDiff = positions[1] - positions[0];
    return _positionDiff >= minLength;
  }
  // If positions are equal or undefined
  else {
    return 0 >= minLength;
  }
}